import useReports from '../../../../hooks/data/useReports';
import useAuthSession from '../../../../lib/auth/hooks/useAuthSession';
import ActionCount from '../../../Action/ActionCount/ActionCount';
import ActiveLink from '../../../common/ActiveLink';
import Icon from '../../../common/Icon/Icon';
import styles from './SideNav.module.css';

const SideNav = () => {
    const { session } = useAuthSession({ required: true });
    const { singleSiteId } = session?.user ?? { singleSiteId: null };
    // See TopNavigation: hidden unless this user has been allocated at least one report.
    const { hasReports } = useReports();
    return (
        <div className="space-y-1 mt-2">
            <ActiveLink href="/" className={styles.navLink} activeClassName={styles.navLinkActive}>
                <Icon icon="grid" />
                Dashboard
            </ActiveLink>

            {singleSiteId ? (
                <ActiveLink
                    href={`/sites/${singleSiteId}`}
                    partiallyActive
                    className={styles.navLink}
                    activeClassName={styles.navLinkActive}
                >
                    <Icon icon="pin" />
                    Site
                </ActiveLink>
            ) : (
                <ActiveLink
                    href="/sites"
                    partiallyActive
                    className={styles.navLink}
                    activeClassName={styles.navLinkActive}
                >
                    <Icon icon="pin" />
                    Sites
                </ActiveLink>
            )}

            <ActiveLink
                href="/actions"
                partiallyActive
                className={styles.navLink}
                activeClassName={styles.navLinkActive}
            >
                <Icon icon="sun" />
                Actions
                <ActionCount />
            </ActiveLink>

            {hasReports ? (
                <ActiveLink
                    href="/reports"
                    partiallyActive
                    className={styles.navLink}
                    activeClassName={styles.navLinkActive}
                >
                    <Icon icon="line_chart" />
                    Reports
                </ActiveLink>
            ) : null}

            <ActiveLink
                href="/health-and-safety"
                partiallyActive
                className={styles.navLink}
                activeClassName={styles.navLinkActive}
            >
                <Icon icon="folder" />
                Health &amp; Safety
            </ActiveLink>

            <ActiveLink
                href="/contacts"
                partiallyActive
                className={styles.navLink}
                activeClassName={styles.navLinkActive}
            >
                <Icon icon="id_card" />
                Contacts
            </ActiveLink>

            <ActiveLink
                href="/profile"
                partiallyActive
                className={styles.navLink}
                activeClassName={styles.navLinkActive}
            >
                <Icon icon="user" />
                Your Account
            </ActiveLink>
        </div>
    );
};

export default SideNav;
